// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".summaryIndex[data-v-387ba67f]{width:1200px;height:auto;background:#fff;border-radius:8px;margin-top:16px}.summaryIndex .list-bj .list-item[data-v-387ba67f]{cursor:pointer;text-align:left;height:48px;line-height:48px;padding-left:8px}.summaryIndex .list-bj .list-item .item-name[data-v-387ba67f]{font-size:14px;font-family:PingFangSC,PingFang SC;font-weight:500;color:#aaa}", ""]);
// Exports
module.exports = exports;
